import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ServiceCard } from "../molecules/ServiceCard";
import { Button } from "@/shared/ui";
import { UserGroupIcon } from "@heroicons/react/24/outline";

export const ServicesSection: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const services = [
    {
      icon: "document",
      title: t("landing.services.laborContracts.title"),
      description: t("landing.services.laborContracts.description"),
    },
    {
      icon: "scale",
      title: t("landing.services.disputeResolution.title"),
      description: t("landing.services.disputeResolution.description"),
    },
    {
      icon: "shield",
      title: t("landing.services.nda.title"),
      description: t("landing.services.nda.description"),
    },
    {
      icon: "globe",
      title: t("landing.services.allDocuments.title"),
      description: t("landing.services.allDocuments.description"),
    },
  ];

  return (
    <section id="features" className="py-12 md:py-20 bg-romance-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-display font-bold text-tiber-900 mb-3 md:mb-4">
            {t("landing.services.title")}
          </h2>
          <p className="text-tiber-800 text-base md:text-lg max-w-2xl mx-auto px-4">
            {t("landing.services.description")}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8 md:mb-12">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>

        {/* Lawyers Directory CTA */}
        <div
          role="region"
          aria-label={t("landing.services.findLawyers.title")}
          className="bg-tiber-600 rounded-xl p-6 md:p-8 text-white flex flex-col sm:flex-row items-center justify-between gap-6 shadow-lg border-2 border-tiber-500"
        >
          <div className="flex items-start gap-4 text-center sm:text-left">
            <div className="mx-auto sm:mx-0 w-14 h-14 rounded-lg bg-white/20 flex items-center justify-center shrink-0">
              <UserGroupIcon className="w-8 h-8" />
            </div>
            <div>
              <h3 className="text-xl md:text-2xl font-bold mb-2">
                {t("landing.services.findLawyers.title")}
              </h3>
              <p className="text-white/90 text-sm md:text-base max-w-xl">
                {t("landing.services.findLawyers.description")}
              </p>
            </div>
          </div>
          <Button
            variant="primary"
            size="lg"
            onClick={() => navigate("/lawyers")}
            className="solid border-2 border-white text-white hover:bg-white hover:text-tiber-600 shrink-0 w-full sm:w-auto"
          >
            {t("landing.services.findLawyers.cta")}
          </Button>
        </div>
      </div>
    </section>
  );
};
